// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ImageGroup: MarkdocTagRegistration = {
  tag: 'images',
  component: 'ImageGroup',
  attributes: {
    background: {
      description: 'Color of the background',
      type: String,
    },
    video: {
      description: 'Optional link to a video to be shown in a popup',
      type: String,
    },
  },
};
